import { render, staticRenderFns } from "./PublicationAudioItemSearch.vue?vue&type=template&id=7c13f232&scoped=true&lang=pug"
import script from "./PublicationAudioItemSearch.vue?vue&type=script&lang=js"
export * from "./PublicationAudioItemSearch.vue?vue&type=script&lang=js"
import style0 from "./PublicationAudioItemSearch.vue?vue&type=style&index=0&id=7c13f232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13f232",
  null
  
)

export default component.exports